/// <reference path="../../types/signalr.d.ts" />

namespace SP {
    export class SoundItem {
        url: string;
        volume: number;
        vibrateTime: number;
        sounds: HTMLAudioElement[] = [];
        lastplay: number;

        constructor(url: string, volume = 1, vibrateTime = 0) {
            this.url = url;
            this.volume = volume;
            this.vibrateTime = vibrateTime;
        }

        async play() {
            //min 50ms interval for sounds
            var now = performance.now();
            if (now - this.lastplay < 50) return;
            this.lastplay = now;

            //get from cache
            var a = this.sounds.splice(0, 1)[0];

            //create new sound if no present
            if (a == null) a = new Audio(this.url);

            //vibrate of needed
            if (this.vibrateTime > 0) window.navigator?.vibrate(this.vibrateTime);

            //set volume
            a.volume = this.volume;

            //play
            await a.play();
          
            //wait  duration
            await SP.sleep((a.duration * 1000));

            //cache sound object
            this.sounds.push(a);
        }
    }
}